class LaravelErrors {
	static getFirstErrorOnly (laravelErrors) {
		const errors = {};
		Object.keys(laravelErrors).forEach((key) => {
			errors[key] = laravelErrors[key][0];
		});
		return errors;
	}

	static getErrorsFromResponseError(err){
		return this.getFirstErrorOnly(err.response?.data?.errors || {});
	}
}

export default LaravelErrors;
